/**
 * My Loans（/application/myloans）。与 LOS `web/los/src/statsig/events/loans.ts` 对齐。
 * 打开页面打 STATSIG.COMMON.VIEW，value=loans。
 *
 * 借款端在用：
 * - New application 按钮
 * - 列表 Continue / View 打开贷款
 *
 * 建贷成功仍打 STATSIG.LOAN.INSERT（LOAN_INSERT，source=my_loans_v2），
 * 不另打 LOANS_LOAN_INSERT，避免与 LOS 列表侧命名混用两套 INSERT。
 * 无分配 / 归档（B 端专用）。
 */
export enum LoansEvent {
    /**
     * New application 按钮点击。
     * value 与 metadata.type 相同：create_manually
     */
    CREATE_NEW_LOAN_BUTTON = 'LOANS_CREATE_NEW_LOAN_BUTTON',
    /**
     * 从列表打开一笔贷款。
     * value=loan_id
     * metadata.source=list；metadata.target_link=跳转路径
     */
    LOAN_OPEN = 'LOANS_LOAN_OPEN',
}
